import buildMessage from '../components/device/presetBuilding'
import paths from '../constants/deviceResourcePaths.js'
import { asyncFetchBuffer } from '../utilities'

import {
  CONNECT,
  RECONNECT,
  DISCONNECT,
  DEVICE_SEND_PRESET_TO_BUFFER,
  DEVICE_ENTER_BOOTLOADER,
  DEVICE_UPDATE_FIRMWARE,
  FETCH_FIRMWARE,
  BOOTLOADER_READY,
  SEND_FIRMWARE,
  FIRMWARE_UPDATE_COMPLETE,
  REQUEST_FIRMWARE_VERSION,
  SET_FIRMWARE_VERSION
} from './actionTypes'

import {
  openDeviceSync,
  setStatusMessage
} from './'

// k-board doesn't have a bootloader so we have to listen for disconnects/reconnects to determine when firmware updating is complete
let firmwareUpdateDisconnects = 0
// Device Connections
export const deviceConnection = (status) => {
  return (dispatch, getState) => {
    const updatingFirmware = getState().device.updatingFirmware
    const availableFirmware = getState().device.availableFirmware

    switch (status) {
      case 'connected':
        dispatch({ type: CONNECT })
        dispatch(setStatusMessage(status))
        dispatch(requestFirmwareVersion())
        setTimeout(() => {
          dispatch(openDeviceSync(true))
        }, 1000)

        break;
      case 'disconnected':
        dispatch({ type: DISCONNECT })
        dispatch(setStatusMessage(updatingFirmware ? 'updating firmware' : status))
        dispatch(openDeviceSync(false))
        if (updatingFirmware) firmwareUpdateDisconnects++

        break;
      case 'reconnected':
        if (firmwareUpdateDisconnects === 2) {
          dispatch({ type: FIRMWARE_UPDATE_COMPLETE })
          dispatch(setStatusMessage('complete!'))
          setTimeout(() => {
            dispatch(setStatusMessage('connected'))
          }, 2000)
          
          firmwareUpdateDisconnects = 0
        }

        if (!updatingFirmware) {
          dispatch(requestFirmwareVersion())
          dispatch(openDeviceSync(true))
        } 

        dispatch({ type: RECONNECT })
        if (!updatingFirmware) dispatch(setStatusMessage(updatingFirmware ? 'updating firmware' : 'connected'))

        break;
      case 'updatingfirmware':
        dispatch({ type: DISCONNECT })
        dispatch(setStatusMessage(`updating firmware to ${availableFirmware.version}`))

        break;
      default:

    }
  }
};

export const sendPreset = () => {
  return (dispatch, getState) => {
    const currentPreset = buildMessage(getState().currentPreset)

    dispatch({type: DEVICE_SEND_PRESET_TO_BUFFER})
    if(window.kBoard && window.kBoard.isConnected()){
      window.kBoard.sendPreset(currentPreset)
    }
  }
}

export const fetchFirmware = (url) => {
  return (dispatch, getState) => {
    dispatch({type: DEVICE_UPDATE_FIRMWARE})
    dispatch({type: FETCH_FIRMWARE})
    dispatch(setStatusMessage('updating firmware'))

    asyncFetchBuffer(paths.base+url)
    .then(firmwareBuffer => {
      console.log('>> K-Board: firmware downloaded');
      if(window.kBoard && window.kBoard.isConnected()){
        window.kBoard.once('bootloader', (status) => {
          dispatch({type:BOOTLOADER_READY})
          dispatch({type:SEND_FIRMWARE})
          console.log('>> K-Board: bootloader ready, sending firmware');
          window.setTimeout(() => window.kBoard.send(new Uint8Array(firmwareBuffer)), 1000)
        })

        window.kBoard.enterBootloader()
        dispatch({type:DEVICE_ENTER_BOOTLOADER})
      }
    })
    .catch(err => console.warn('>> K-Board: firmware download failed', err))
  }
};

export const requestFirmwareVersion = () => {
  return (dispatch) => {
    dispatch({ type: REQUEST_FIRMWARE_VERSION })

    if(window.kBoard && window.kBoard.isConnected()) {
      window.kBoard.once('version', (versions) => {
        dispatch(setFirmwareVersion(versions))
      })

      window.kBoard.getFirmwareVersion()
    }
  }
};

export const setFirmwareVersion = (versions) => {
  return ({
    type: SET_FIRMWARE_VERSION,
    bootloader: versions.bootloader,
    firmware: versions.firmware
  })
}
